/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentProps } from 'react';

import { WithLabelWrapper } from 'components/Blocks';

import { DecimalInput } from './DecimalInput';
import { MonetaryInput } from './MonetaryInput';

const DecimalWithLabel = WithLabelWrapper(DecimalInput);

const inputs = {
  CURRENCY: MonetaryInput,
  NUMBER: DecimalWithLabel,
};

type Inputs = typeof inputs;

type VariableCost = keyof Inputs;

type VariableCostInputProps<Type extends VariableCost> = {
  children?: never;

  type: Type;
} & ComponentProps<Inputs[Type]>;

export function VariableCostInput<Type extends VariableCost>({
  type,
  ...props
}: VariableCostInputProps<Type>) {
  const Comp = inputs[type];

  return <Comp {...(props as any)} />;
}
